<template>
  <div class="row">
    <div class="w-100">
      <p class="fs-12 fw-500 txt-grey-800">{{ getDtTop }}</p>
      <div class="d-flex justify-content-between align-items-center mb-3">
        <p class="fs-24 fw-600 txt-grey-900 mb-0">{{ clinic && clinic.name }}</p>
        <div
          class="cursor-pointer d-flex justify-content-end"
          :class="type == 'clinic-settings' ? 'active' : ''"
          v-if="isOwnerWorkspace"
        >
          <svg
            width="50"
            height="50"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class
            @click="changeType('clinic-settings')"
          >
            <g filter="url(#filter0_b_17161_79559)">
              <rect width="48" height="48" rx="24" fill="white" fill-opacity="0.8" />
              <path
                d="M31.4323 24.98C31.4723 24.66 31.5023 24.34 31.5023 24C31.5023 23.66 31.4723 23.34 31.4323 23.02L33.5423 21.37C33.7323 21.22 33.7823 20.95 33.6623 20.73L31.6623 17.27C31.5723 17.11 31.4023 17.02 31.2223 17.02C31.1623 17.02 31.1023 17.03 31.0523 17.05L28.5623 18.05C28.0423 17.65 27.4823 17.32 26.8723 17.07L26.4923 14.42C26.4623 14.18 26.2523 14 26.0023 14H22.0023C21.7523 14 21.5423 14.18 21.5123 14.42L21.1323 17.07C20.5223 17.32 19.9623 17.66 19.4423 18.05L16.9523 17.05C16.8923 17.03 16.8323 17.02 16.7723 17.02C16.6023 17.02 16.4323 17.11 16.3423 17.27L14.3423 20.73C14.2123 20.95 14.2723 21.22 14.4623 21.37L16.5723 23.02C16.5323 23.34 16.5023 23.67 16.5023 24C16.5023 24.33 16.5323 24.66 16.5723 24.98L14.4623 26.63C14.2723 26.78 14.2223 27.05 14.3423 27.27L16.3423 30.73C16.4323 30.89 16.6023 30.98 16.7823 30.98C16.8423 30.98 16.9023 30.97 16.9523 30.95L19.4423 29.95C19.9623 30.35 20.5223 30.68 21.1323 30.93L21.5123 33.58C21.5423 33.82 21.7523 34 22.0023 34H26.0023C26.2523 34 26.4623 33.82 26.4923 33.58L26.8723 30.93C27.4823 30.68 28.0423 30.34 28.5623 29.95L31.0523 30.95C31.1123 30.97 31.1723 30.98 31.2323 30.98C31.4023 30.98 31.5723 30.89 31.6623 30.73L33.6623 27.27C33.7823 27.05 33.7323 26.78 33.5423 26.63L31.4323 24.98ZM29.4523 23.27C29.4923 23.58 29.5023 23.79 29.5023 24C29.5023 24.21 29.4823 24.43 29.4523 24.73L29.3123 25.86L30.2023 26.56L31.2823 27.4L30.5823 28.61L29.3123 28.1L28.2723 27.68L27.3723 28.36C26.9423 28.68 26.5323 28.92 26.1223 29.09L25.0623 29.52L24.9023 30.65L24.7023 32H23.3023L22.9523 29.52L21.8923 29.09C21.4623 28.91 21.0623 28.68 20.6623 28.38L19.7523 27.68L18.6923 28.11L17.4223 28.62L16.7223 27.41L17.8023 26.57L18.6923 25.87L18.5523 24.74C18.5223 24.43 18.5023 24.2 18.5023 24C18.5023 23.8 18.5223 23.57 18.5523 23.27L18.6923 22.14L17.8023 21.44L16.7223 20.6L17.4223 19.39L18.6923 19.9L19.7323 20.32L20.6323 19.64C21.0623 19.32 21.4723 19.08 21.8823 18.91L22.9423 18.48L23.1023 17.35L23.3023 16H24.6923L25.0423 18.48L26.1023 18.91C26.5323 19.09 26.9323 19.32 27.3323 19.62L28.2423 20.32L29.3023 19.89L30.5723 19.38L31.2723 20.59L30.2023 21.44L29.3123 22.14L29.4523 23.27ZM24.0023 20C21.7923 20 20.0023 21.79 20.0023 24C20.0023 26.21 21.7923 28 24.0023 28C26.2123 28 28.0023 26.21 28.0023 24C28.0023 21.79 26.2123 20 24.0023 20ZM24.0023 26C22.9023 26 22.0023 25.1 22.0023 24C22.0023 22.9 22.9023 22 24.0023 22C25.1023 22 26.0023 22.9 26.0023 24C26.0023 25.1 25.1023 26 24.0023 26Z"
                fill="#475467"
              />
            </g>
            <defs>
              <filter
                id="filter0_b_17161_79559"
                x="-48"
                y="-48"
                width="144"
                height="144"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feGaussianBlur in="BackgroundImage" stdDeviation="24" />
                <feComposite
                  in2="SourceAlpha"
                  operator="in"
                  result="effect1_backgroundBlur_17161_79559"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_backgroundBlur_17161_79559"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        </div>
      </div>
    </div>

    <div>
      <div class="d-flex justify-content-end" id="headingOne">
        <button
          class="d-md-none btn"
          data-toggle="collapse"
          data-target="#collapseOne"
          aria-expanded="true"
          aria-controls="collapseOne"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="m-0"
          >
            <path
              d="M3 7H21C21.2652 7 21.5196 6.89464 21.7071 6.70711C21.8946 6.51957 22 6.26522 22 6C22 5.73478 21.8946 5.48043 21.7071 5.29289C21.5196 5.10536 21.2652 5 21 5H3C2.73478 5 2.48043 5.10536 2.29289 5.29289C2.10536 5.48043 2 5.73478 2 6C2 6.26522 2.10536 6.51957 2.29289 6.70711C2.48043 6.89464 2.73478 7 3 7ZM21 17H3C2.73478 17 2.48043 17.1054 2.29289 17.2929C2.10536 17.4804 2 17.7348 2 18C2 18.2652 2.10536 18.5196 2.29289 18.7071C2.48043 18.8946 2.73478 19 3 19H21C21.2652 19 21.5196 18.8946 21.7071 18.7071C21.8946 18.5196 22 18.2652 22 18C22 17.7348 21.8946 17.4804 21.7071 17.2929C21.5196 17.1054 21.2652 17 21 17ZM21 13H3C2.73478 13 2.48043 13.1054 2.29289 13.2929C2.10536 13.4804 2 13.7348 2 14C2 14.2652 2.10536 14.5196 2.29289 14.7071C2.48043 14.8946 2.73478 15 3 15H21C21.2652 15 21.5196 14.8946 21.7071 14.7071C21.8946 14.5196 22 14.2652 22 14C22 13.7348 21.8946 13.4804 21.7071 13.2929C21.5196 13.1054 21.2652 13 21 13ZM21 9H3C2.73478 9 2.48043 9.10536 2.29289 9.29289C2.10536 9.48043 2 9.73478 2 10C2 10.2652 2.10536 10.5196 2.29289 10.7071C2.48043 10.8946 2.73478 11 3 11H21C21.2652 11 21.5196 10.8946 21.7071 10.7071C21.8946 10.5196 22 10.2652 22 10C22 9.73478 21.8946 9.48043 21.7071 9.29289C21.5196 9.10536 21.2652 9 21 9Z"
              fill="black"
            />
          </svg>
        </button>
      </div>

      <div
        id="collapseOne"
        class="collapse"
        :class="showMenu ? 'show' : ''"
        aria-labelledby="headingOne"
        data-parent="#accordion"
      >
        <div class="flex flex-wrap md:flex-nowrap justify-between items-center">
          <div class="cs-item mb-2">
            <div
              class="cursor-pointer text-center"
              :class="type == 'clinic-disease-template' ? 'active' : ''"
            >
              <svg
                width="65"
                height="64"
                viewBox="0 0 56 56"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                href="javascript:;"
                class="mb-2"
                @click="changeType('concluding')"
              >
                <g filter="url(#filter0_b_18829_80788)">
                  <rect width="56" height="56" rx="16" fill="#20419B" />
                  <path
                    d="M38.78 26.37C38.6859 26.254 38.567 26.1605 38.432 26.0965C38.297 26.0325 38.1494 25.9995 38 26H36V25C36 24.2044 35.6839 23.4413 35.1213 22.8787C34.5587 22.3161 33.7956 22 33 22H26.72L26.4 21C26.1926 20.4133 25.8077 19.9055 25.2989 19.5472C24.7901 19.1888 24.1824 18.9976 23.56 19H20C19.2044 19 18.4413 19.3161 17.8787 19.8787C17.3161 20.4413 17 21.2044 17 22V34C17 34.7957 17.3161 35.5587 17.8787 36.1213C18.4413 36.684 19.2044 37 20 37H34.4C35.0812 36.998 35.7415 36.7643 36.2722 36.3372C36.8029 35.9101 37.1724 35.3151 37.32 34.65L39 27.22C39.0304 27.0709 39.0264 26.9169 38.9883 26.7696C38.9502 26.6223 38.8789 26.4856 38.78 26.37ZM21.37 34.22C21.3192 34.4456 21.1918 34.6466 21.0095 34.7888C20.8271 34.931 20.6012 35.0057 20.37 35H20C19.7348 35 19.4804 34.8947 19.2929 34.7071C19.1054 34.5196 19 34.2652 19 34V22C19 21.7348 19.1054 21.4805 19.2929 21.2929C19.4804 21.1054 19.7348 21 20 21H23.56C23.7781 20.9886 23.9939 21.0489 24.1744 21.1717C24.355 21.2945 24.4904 21.473 24.56 21.68L25.1 23.32C25.1642 23.5108 25.2844 23.6777 25.445 23.799C25.6055 23.9204 25.799 23.9904 26 24H33C33.2652 24 33.5196 24.1054 33.7071 24.2929C33.8946 24.4805 34 24.7348 34 25V26H24C23.7688 25.9944 23.5429 26.069 23.3605 26.2112C23.1782 26.3534 23.0508 26.5544 23 26.78L21.37 34.22ZM35.37 34.22C35.3192 34.4456 35.1918 34.6466 35.0095 34.7888C34.8271 34.931 34.6012 35.0057 34.37 35H23.21C23.2616 34.8886 23.2986 34.771 23.32 34.65L24.8 28H36.8L35.37 34.22Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_b_18829_80788"
                    x="-48"
                    y="-48"
                    width="152"
                    height="152"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feGaussianBlur in="BackgroundImage" stdDeviation="24" />
                    <feComposite
                      in2="SourceAlpha"
                      operator="in"
                      result="effect1_backgroundBlur_18829_80788"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_backgroundBlur_18829_80788"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
              <p
                class="text-center fs-16 fw-500 txt-gery-900"
              >{{ $t("workspace_setting.lbl_meeting_minute") }}</p>
            </div>
          </div>

          <div class="cs-item mb-2">
            <div class="text-center cursor-pointer" @click="joinMeet">
              <svg
                width="64"
                height="64"
                viewBox="0 0 64 64"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g filter="url(#filter0_b_19553_86952)">
                  <rect width="64" height="64" rx="16" fill="#20419B" />
                  <path
                    d="M42.7122 25.8371C42.2322 25.5857 41.2254 25.3229 39.8556 26.26L38.1346 27.4486C38.0059 23.8943 36.4254 22.5 32.5854 22.5H25.561C21.5571 22.5 20 24.02 20 27.9286V37.0714C20 39.7 21.4634 42.5 25.561 42.5H32.5854C36.4254 42.5 38.0059 41.1057 38.1346 37.5514L39.8556 38.74C40.5815 39.2429 41.2137 39.4029 41.7171 39.4029C42.1502 39.4029 42.4898 39.2771 42.7122 39.1629C43.1922 38.9229 44 38.2714 44 36.6371V28.3629C44 26.7286 43.1922 26.0771 42.7122 25.8371ZM30.8293 31.7914C29.6234 31.7914 28.6283 30.8314 28.6283 29.6429C28.6283 28.4543 29.6234 27.4943 30.8293 27.4943C32.0351 27.4943 33.0302 28.4543 33.0302 29.6429C33.0302 30.8314 32.0351 31.7914 30.8293 31.7914Z"
                    fill="#E5E5E5"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_b_19553_86952"
                    x="-48"
                    y="-48"
                    width="160"
                    height="160"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feGaussianBlur in="BackgroundImage" stdDeviation="24" />
                    <feComposite
                      in2="SourceAlpha"
                      operator="in"
                      result="effect1_backgroundBlur_19553_86952"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_backgroundBlur_19553_86952"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>

              <p
                class="text-center fs-16 fw-500 txt-gery-900 mt-2"
              >{{ $t("workspace_setting.lbl_default_meetroom") }}</p>
            </div>
          </div>

          <!-- <div class="w-36 mb-2">
            <div class="text-center cursor-not-allowed">
              <svg
                width="65"
                height="64"
                viewBox="0 0 65 64"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="mb-2"
              >
                <g filter="url(#filter0_b_18638_1337)">
                  <rect x="0.5" width="64" height="64" rx="16" fill="#20419B" />
                  <path
                    d="M37.75 21.3333V20.0833H36.5H21.8333H20.5833V21.3333V32.2267V35.2444L22.7172 33.1105L23.9111 31.9167H36.5H37.75V30.6667V21.3333ZM25.75 38.6667V37.25H41.8333H43.0833V36V25.25H44.5C44.519 25.25 44.5388 25.2567 44.5577 25.2755C44.5766 25.2944 44.5833 25.3143 44.5833 25.3333V42.3156L41.3838 39.1161L41.0177 38.75H40.5H25.8333C25.8143 38.75 25.7944 38.7433 25.7755 38.7244C25.7566 38.7056 25.75 38.6857 25.75 38.6667ZM24.5 32.0833H23.9822L23.6161 32.4494L20.4166 35.6489V20C20.4166 19.981 20.4233 19.9611 20.4422 19.9422C20.4611 19.9233 20.4809 19.9167 20.5 19.9167H37.8333C37.8523 19.9167 37.8722 19.9233 37.8911 19.9422C37.91 19.9611 37.9166 19.981 37.9166 20V32C37.9166 32.019 37.91 32.0389 37.8911 32.0578C37.8722 32.0767 37.8523 32.0833 37.8333 32.0833H24.5Z"
                    stroke="white"
                    stroke-width="2.5"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_b_18638_1337"
                    x="-47.5"
                    y="-48"
                    width="160"
                    height="160"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feGaussianBlur in="BackgroundImage" stdDeviation="24" />
                    <feComposite
                      in2="SourceAlpha"
                      operator="in"
                      result="effect1_backgroundBlur_18638_1337"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_backgroundBlur_18638_1337"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
              <p class="text-center fs-16 fw-500 txt-gery-900">Chat</p>
            </div>
          </div>-->
          <div class="cs-item mb-2">
            <div
              class="text-center cursor-pointer"
              :class="[
                type == 'clinic-banks' ? 'active' : '',
                !isOwnerWorkspace ? 'disabled' : '',
              ]"
            >
              <svg
                width="65"
                height="64"
                viewBox="0 0 56 56"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="robo-16-500 mb-2"
                @click="changeType('clinic-banks')"
              >
                <g filter="url(#filter0_b_18680_80155)">
                  <rect width="56" height="56" rx="16" fill="#20419B" />
                  <path
                    d="M22 32H25.6C25.9183 32 26.2235 31.8314 26.4485 31.5314C26.6736 31.2313 26.8 30.8243 26.8 30.4C26.8 29.9757 26.6736 29.5687 26.4485 29.2686C26.2235 28.9686 25.9183 28.8 25.6 28.8H22C21.6817 28.8 21.3765 28.9686 21.1515 29.2686C20.9264 29.5687 20.8 29.9757 20.8 30.4C20.8 30.8243 20.9264 31.2313 21.1515 31.5314C21.3765 31.8314 21.6817 32 22 32ZM36.4 16H19.6C18.6452 16 17.7295 16.5057 17.0544 17.4059C16.3793 18.3061 16 19.527 16 20.8V35.2C16 36.473 16.3793 37.6939 17.0544 38.5941C17.7295 39.4943 18.6452 40 19.6 40H36.4C37.3548 40 38.2705 39.4943 38.9456 38.5941C39.6207 37.6939 40 36.473 40 35.2V20.8C40 19.527 39.6207 18.3061 38.9456 17.4059C38.2705 16.5057 37.3548 16 36.4 16ZM37.6 35.2C37.6 35.6243 37.4736 36.0313 37.2485 36.3314C37.0235 36.6314 36.7183 36.8 36.4 36.8H19.6C19.2817 36.8 18.9765 36.6314 18.7515 36.3314C18.5264 36.0313 18.4 35.6243 18.4 35.2V25.6H37.6V35.2ZM37.6 22.4H18.4V20.8C18.4 20.3757 18.5264 19.9687 18.7515 19.6686C18.9765 19.3686 19.2817 19.2 19.6 19.2H36.4C36.7183 19.2 37.0235 19.3686 37.2485 19.6686C37.4736 19.9687 37.6 20.3757 37.6 20.8V22.4Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_b_18680_80155"
                    x="-48"
                    y="-48"
                    width="152"
                    height="152"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feGaussianBlur in="BackgroundImage" stdDeviation="24" />
                    <feComposite
                      in2="SourceAlpha"
                      operator="in"
                      result="effect1_backgroundBlur_18680_80155"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_backgroundBlur_18680_80155"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>

              <p
                class="text-center fs-16 fw-500 txt-gery-900"
              >{{ $t("workspace_setting.lbl_payment") }}</p>
            </div>
          </div>

          <div class="cs-item mb-2">
            <div
              class="text-center cursor-pointer"
              :class="type == 'ws-mgmt/consulting-rooms' ? 'active' : ''"
            >
              <svg
                class="mb-2"
                @click="changeType('ws-mgmt/consulting-rooms')"
                width="65"
                height="64"
                viewBox="0 0 65 64"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g filter="url(#filter0_b_23125_118888)">
                  <rect width="65" height="64" rx="16" fill="#20419B" />
                  <path
                    d="M35.94 31.0667C36.546 30.3093 36.8794 29.37 36.8867 28.4C36.8867 27.2366 36.4245 26.1208 35.6018 25.2982C34.7792 24.4755 33.6634 24.0134 32.5 24.0134C31.3366 24.0134 30.2208 24.4755 29.3982 25.2982C28.5755 26.1208 28.1133 27.2366 28.1133 28.4C28.1206 29.37 28.454 30.3093 29.06 31.0667C27.8715 31.7899 26.9391 32.8669 26.3933 34.1467C26.317 34.3091 26.2741 34.4852 26.2674 34.6645C26.2607 34.8438 26.2903 35.0226 26.3544 35.1903C26.4185 35.3579 26.5157 35.5108 26.6403 35.64C26.7649 35.7691 26.9142 35.8718 27.0795 35.9418C27.2447 36.0119 27.4223 36.0478 27.6018 36.0476C27.7812 36.0473 27.9587 36.0108 28.1238 35.9403C28.2888 35.8698 28.4378 35.7667 28.5621 35.6372C28.6863 35.5077 28.7831 35.3545 28.8467 35.1867C29.1531 34.4703 29.6621 33.8591 30.3111 33.428C30.9601 32.9969 31.7209 32.7647 32.5 32.76V32.76C33.2814 32.7622 34.0451 32.9931 34.6967 33.4244C35.3483 33.8556 35.8593 34.4683 36.1667 35.1867C36.2687 35.4277 36.4395 35.6333 36.6576 35.7779C36.8757 35.9226 37.1316 35.9998 37.3933 36C37.5717 35.9967 37.748 35.9605 37.9133 35.8934C38.2385 35.7552 38.4955 35.4937 38.628 35.1662C38.7605 34.8387 38.7576 34.472 38.62 34.1467C38.0708 32.865 37.1335 31.7878 35.94 31.0667V31.0667ZM32.5 30.0934C32.1593 30.0933 31.8262 29.9921 31.543 29.8025C31.2599 29.6129 31.0395 29.3435 30.9097 29.0285C30.7799 28.7134 30.7466 28.3669 30.8141 28.0329C30.8815 27.6989 31.0467 27.3924 31.2886 27.1524C31.5305 26.9124 31.8382 26.7496 32.1727 26.6848C32.5072 26.6199 32.8535 26.6559 33.1675 26.7881C33.4816 26.9204 33.7492 27.1429 33.9366 27.4275C34.124 27.7121 34.2226 28.0459 34.22 28.3867C34.2165 28.8405 34.0337 29.2746 33.7115 29.5943C33.3894 29.914 32.9539 30.0934 32.5 30.0934V30.0934ZM40.5 18.6667H24.5C23.4391 18.6667 22.4217 19.0881 21.6716 19.8383C20.9214 20.5884 20.5 21.6058 20.5 22.6667V37.3334C20.5 38.3942 20.9214 39.4116 21.6716 40.1618C22.4217 40.9119 23.4391 41.3334 24.5 41.3334H27.9533L31.5533 44.9467C31.6779 45.0703 31.8257 45.168 31.9881 45.2344C32.1506 45.3007 32.3245 45.3344 32.5 45.3334C32.8178 45.3334 33.1251 45.2199 33.3667 45.0134L37.66 41.3334H40.5C41.5609 41.3334 42.5783 40.9119 43.3284 40.1618C44.0786 39.4116 44.5 38.3942 44.5 37.3334V22.6667C44.5 21.6058 44.0786 20.5884 43.3284 19.8383C42.5783 19.0881 41.5609 18.6667 40.5 18.6667ZM41.8333 37.3334C41.8333 37.687 41.6929 38.0261 41.4428 38.2762C41.1928 38.5262 40.8536 38.6667 40.5 38.6667H37.1667C36.8489 38.6667 36.5415 38.7801 36.3 38.9867L32.5667 42.1867L29.4467 39.0534C29.3221 38.9298 29.1743 38.832 29.0119 38.7657C28.8494 38.6993 28.6755 38.6657 28.5 38.6667H24.5C24.1464 38.6667 23.8072 38.5262 23.5572 38.2762C23.3071 38.0261 23.1667 37.687 23.1667 37.3334V22.6667C23.1667 22.3131 23.3071 21.9739 23.5572 21.7239C23.8072 21.4738 24.1464 21.3334 24.5 21.3334H40.5C40.8536 21.3334 41.1928 21.4738 41.4428 21.7239C41.6929 21.9739 41.8333 22.3131 41.8333 22.6667V37.3334Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_b_23125_118888"
                    x="-48"
                    y="-48"
                    width="161"
                    height="160"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="24" />
                    <feComposite
                      in2="SourceAlpha"
                      operator="in"
                      result="effect1_backgroundBlur_23125_118888"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_backgroundBlur_23125_118888"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>

              <p
                class="text-center fs-16 fw-500 txt-gery-900"
              >{{ $t("workspace_setting.lbl_consulting_room") }}</p>
            </div>
          </div>
        </div>

        <div class="flex flex-wrap gap-4 items-center justify-between">
          <div class="cs-item mb-2">
            <div
              class="text-center cursor-pointer"
              :class="type == 'clinic-disease-template' ? 'active' : ''"
            >
              <svg
                width="65"
                height="64"
                viewBox="0 0 65 64"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                href="javascript:;"
                class="mb-2"
                @click="changeType('clinic-disease-template')"
              >
                <g filter="url(#filter0_b_17161_79579)">
                  <rect x="0.5" width="64" height="64" rx="16" fill="#20419B" />
                  <path
                    d="M31.6161 24.8839L31.9822 25.25H32.5H43.1666C43.4112 25.25 43.6402 25.3102 43.8398 25.4167H43.1666H31.9111L29.6105 23.1161L29.2444 22.75H28.7266H21.8333H21.1638C21.3622 22.6433 21.59 22.5833 21.8333 22.5833H29.3155L31.6161 24.8839ZM44.4166 26.6667V25.9935C44.5231 26.1931 44.5833 26.4221 44.5833 26.6667V40C44.5833 40.2446 44.5231 40.4736 44.4166 40.6732V40V26.6667ZM43.1666 41.25H43.8398C43.6402 41.3565 43.4112 41.4167 43.1666 41.4167H21.8333C21.5887 41.4167 21.3597 41.3565 21.1601 41.25H21.8333H43.1666ZM20.5833 40V40.6731C20.4768 40.4737 20.4167 40.2448 20.4166 40.0004C20.4166 40.0003 20.4166 40.0001 20.4166 40L20.43 24.001V24C20.43 23.7623 20.4851 23.5405 20.5833 23.3463V24V40ZM36.4166 34.6667V33.4167H35.1666H33.75V33.25H35.1666H36.4166V32V30.5833H36.5833V32V33.25H37.8333H39.25V33.4167H37.8333H36.5833V34.6667V36.0833H36.4166V34.6667Z"
                    stroke="white"
                    stroke-width="2.5"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_b_17161_79579"
                    x="-47.5"
                    y="-48"
                    width="160"
                    height="160"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feGaussianBlur in="BackgroundImage" stdDeviation="24" />
                    <feComposite
                      in2="SourceAlpha"
                      operator="in"
                      result="effect1_backgroundBlur_17161_79579"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_backgroundBlur_17161_79579"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
              <p
                class="text-center fs-16 fw-500 txt-gery-900"
              >{{ $t("workspace_setting.lbl_careplan_template") }}</p>
            </div>
          </div>

          <div class="cs-item mb-2">
            <div class="text-center flex flex-col items-center gap-2 cursor-pointer">
              <div
                @click="handleRedirectEmrTemplate"
                class="flex items-center justify-center rounded-2xl"
                style="width: 65px; height: 65px; background-color: #20419b"
              >
                <svg
                  class="ml-2"
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.5 20H5.5C5.23478 20 4.98043 19.8946 4.79289 19.7071C4.60536 19.5196 4.5 19.2652 4.5 19V5C4.5 4.73478 4.60536 4.48043 4.79289 4.29289C4.98043 4.10536 5.23478 4 5.5 4H10.5V7C10.5 7.79565 10.8161 8.55871 11.3787 9.12132C11.9413 9.68393 12.7044 10 13.5 10H16.5V15C16.5 15.2652 16.6054 15.5196 16.7929 15.7071C16.9804 15.8946 17.2348 16 17.5 16C17.7652 16 18.0196 15.8946 18.2071 15.7071C18.3946 15.5196 18.5 15.2652 18.5 15V9C18.5 9 18.5 9 18.5 8.94C18.4896 8.84813 18.4695 8.75763 18.44 8.67V8.58C18.3919 8.47718 18.3278 8.38267 18.25 8.3L12.25 2.3C12.1673 2.22222 12.0728 2.15808 11.97 2.11C11.9369 2.10421 11.9031 2.10421 11.87 2.11C11.7728 2.058 11.6683 2.02092 11.56 2H5.5C4.70435 2 3.94129 2.31607 3.37868 2.87868C2.81607 3.44129 2.5 4.20435 2.5 5V19C2.5 19.7956 2.81607 20.5587 3.37868 21.1213C3.94129 21.6839 4.70435 22 5.5 22H11.5C11.7652 22 12.0196 21.8946 12.2071 21.7071C12.3946 21.5196 12.5 21.2652 12.5 21C12.5 20.7348 12.3946 20.4804 12.2071 20.2929C12.0196 20.1054 11.7652 20 11.5 20ZM12.5 5.41L15.09 8H13.5C13.2348 8 12.9804 7.89464 12.7929 7.70711C12.6054 7.51957 12.5 7.26522 12.5 7V5.41ZM7.5 14H13.5C13.7652 14 14.0196 13.8946 14.2071 13.7071C14.3946 13.5196 14.5 13.2652 14.5 13C14.5 12.7348 14.3946 12.4804 14.2071 12.2929C14.0196 12.1054 13.7652 12 13.5 12H7.5C7.23478 12 6.98043 12.1054 6.79289 12.2929C6.60536 12.4804 6.5 12.7348 6.5 13C6.5 13.2652 6.60536 13.5196 6.79289 13.7071C6.98043 13.8946 7.23478 14 7.5 14ZM11.5 16H7.5C7.23478 16 6.98043 16.1054 6.79289 16.2929C6.60536 16.4804 6.5 16.7348 6.5 17C6.5 17.2652 6.60536 17.5196 6.79289 17.7071C6.98043 17.8946 7.23478 18 7.5 18H11.5C11.7652 18 12.0196 17.8946 12.2071 17.7071C12.3946 17.5196 12.5 17.2652 12.5 17C12.5 16.7348 12.3946 16.4804 12.2071 16.2929C12.0196 16.1054 11.7652 16 11.5 16ZM7.5 10H8.5C8.76522 10 9.01957 9.89464 9.20711 9.70711C9.39464 9.51957 9.5 9.26522 9.5 9C9.5 8.73478 9.39464 8.48043 9.20711 8.29289C9.01957 8.10536 8.76522 8 8.5 8H7.5C7.23478 8 6.98043 8.10536 6.79289 8.29289C6.60536 8.48043 6.5 8.73478 6.5 9C6.5 9.26522 6.60536 9.51957 6.79289 9.70711C6.98043 9.89464 7.23478 10 7.5 10ZM21.21 16.29C21.117 16.1963 21.0064 16.1219 20.8846 16.0711C20.7627 16.0203 20.632 15.9942 20.5 15.9942C20.368 15.9942 20.2373 16.0203 20.1154 16.0711C19.9936 16.1219 19.883 16.1963 19.79 16.29L16.5 19.59L15.21 18.29C15.1168 18.1968 15.0061 18.1228 14.8842 18.0723C14.7624 18.0219 14.6319 17.9959 14.5 17.9959C14.3681 17.9959 14.2376 18.0219 14.1158 18.0723C13.9939 18.1228 13.8832 18.1968 13.79 18.29C13.6968 18.3832 13.6228 18.4939 13.5723 18.6158C13.5219 18.7376 13.4959 18.8681 13.4959 19C13.4959 19.1319 13.5219 19.2624 13.5723 19.3842C13.6228 19.5061 13.6968 19.6168 13.79 19.71L15.79 21.71C15.883 21.8037 15.9936 21.8781 16.1154 21.9289C16.2373 21.9797 16.368 22.0058 16.5 22.0058C16.632 22.0058 16.7627 21.9797 16.8846 21.9289C17.0064 21.8781 17.117 21.8037 17.21 21.71L21.21 17.71C21.3037 17.617 21.3781 17.5064 21.4289 17.3846C21.4797 17.2627 21.5058 17.132 21.5058 17C21.5058 16.868 21.4797 16.7373 21.4289 16.6154C21.3781 16.4936 21.3037 16.383 21.21 16.29Z"
                    fill="white"
                  />
                </svg>
              </div>
              <p
                class="text-center fs-16 fw-500 txt-gery-900"
              >{{ $t("workspace_setting.lbl_emr_template") }}</p>
            </div>
          </div>

          <div class="cs-item mb-2">
            <div
              class="text-center cursor-pointer"
              :class="type == 'clinic-stats' ? 'active' : ''"
              @click="changeType('clinic-stats')"
            >
              <svg
                width="65"
                height="64"
                viewBox="0 0 56 56"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="mb-2"
              >
                <g filter="url(#filter0_b_18680_80167)">
                  <rect width="56" height="56" rx="16" fill="#20419B" />
                  <path
                    d="M34.5454 20.3661H35.6363V21.4568C35.6363 21.7461 35.7513 22.0236 35.9558 22.2281C36.1604 22.4327 36.4379 22.5476 36.7272 22.5476C37.0166 22.5476 37.294 22.4327 37.4986 22.2281C37.7032 22.0236 37.8181 21.7461 37.8181 21.4568V20.3661H38.909C39.1984 20.3661 39.4758 20.2511 39.6804 20.0466C39.885 19.842 40 19.5646 40 19.2753C40 18.986 39.885 18.7085 39.6804 18.504C39.4758 18.2994 39.1984 18.1845 38.909 18.1845H37.8181V17.0937C37.8181 16.8044 37.7032 16.527 37.4986 16.3224C37.294 16.1179 37.0166 16.003 36.7272 16.003C36.4379 16.003 36.1604 16.1179 35.9558 16.3224C35.7513 16.527 35.6363 16.8044 35.6363 17.0937V18.1845H34.5454C34.2561 18.1845 33.9786 18.2994 33.774 18.504C33.5694 18.7085 33.4545 18.986 33.4545 19.2753C33.4545 19.5646 33.5694 19.842 33.774 20.0466C33.9786 20.2511 34.2561 20.3661 34.5454 20.3661ZM26.9091 24.7292V31.2738C26.9091 32.1417 27.2539 32.974 27.8676 33.5877C28.4814 34.2014 29.3138 34.5461 30.1818 34.5461H31.2727C32.1407 34.5461 32.9731 34.2014 33.5869 33.5877C34.2006 32.974 34.5454 32.1417 34.5454 31.2738V24.7292C34.5454 23.8613 34.2006 23.0289 33.5869 22.4153C32.9731 21.8016 32.1407 21.4568 31.2727 21.4568H30.1818C29.3138 21.4568 28.4814 21.8016 27.8676 22.4153C27.2539 23.0289 26.9091 23.8613 26.9091 24.7292ZM32.3636 24.7292V31.2738C32.3636 31.5631 32.2487 31.8405 32.0441 32.0451C31.8395 32.2497 31.562 32.3646 31.2727 32.3646H30.1818C29.8925 32.3646 29.615 32.2497 29.4104 32.0451C29.2058 31.8405 29.0909 31.5631 29.0909 31.2738V24.7292C29.0909 24.4399 29.2058 24.1624 29.4104 23.9579C29.615 23.7533 29.8925 23.6384 30.1818 23.6384H31.2727C31.562 23.6384 31.8395 23.7533 32.0441 23.9579C32.2487 24.1624 32.3636 24.4399 32.3636 24.7292ZM38.4727 24.7292C38.3323 24.7578 38.1989 24.8138 38.0801 24.894C37.9614 24.9741 37.8596 25.0769 37.7806 25.1965C37.7015 25.316 37.6468 25.4499 37.6196 25.5906C37.5924 25.7312 37.5931 25.8759 37.6218 26.0163C38.0477 28.0846 37.7953 30.2351 36.9019 32.1486C36.0085 34.0621 34.5219 35.6366 32.6627 36.6383C30.8034 37.64 28.6707 38.0156 26.581 37.7092C24.4914 37.4029 22.5563 36.431 21.0629 34.9377C19.5695 33.4445 18.5974 31.5096 18.2911 29.4202C17.9847 27.3309 18.3603 25.1984 19.3621 23.3394C20.3639 21.4803 21.9386 19.9939 23.8523 19.1006C25.7661 18.2074 27.9168 17.955 29.9854 18.3808C30.2748 18.4387 30.5752 18.3793 30.8207 18.2156C31.0662 18.052 31.2367 17.7975 31.2945 17.5082C31.3524 17.2189 31.2929 16.9185 31.1293 16.673C30.9656 16.4276 30.7111 16.2572 30.4218 16.1993C29.6234 16.0506 28.8119 15.9848 28 16.003C25.6266 16.003 23.3065 16.7067 21.3332 18.0251C19.3598 19.3435 17.8217 21.2174 16.9134 23.4098C16.0052 25.6023 15.7676 28.0148 16.2306 30.3423C16.6936 32.6698 17.8365 34.8077 19.5147 36.4857C21.1929 38.1637 23.3311 39.3065 25.6589 39.7694C27.9867 40.2324 30.3995 39.9948 32.5922 39.0867C34.7849 38.1785 36.659 36.6406 37.9776 34.6675C39.2962 32.6944 40 30.3746 40 28.0015C40.0023 27.1955 39.9218 26.3914 39.76 25.6018C39.7338 25.4594 39.6796 25.3237 39.6005 25.2025C39.5214 25.0813 39.4189 24.977 39.2991 24.8958C39.1793 24.8146 39.0446 24.7581 38.9027 24.7294C38.7608 24.7008 38.6146 24.7007 38.4727 24.7292ZM22.5454 22.5476V33.4553C22.5454 33.7446 22.6604 34.0221 22.865 34.2266C23.0695 34.4312 23.347 34.5461 23.6364 34.5461C23.9257 34.5461 24.2032 34.4312 24.4077 34.2266C24.6123 34.0221 24.7273 33.7446 24.7273 33.4553V22.5476C24.7273 22.2583 24.6123 21.9809 24.4077 21.7763C24.2032 21.5717 23.9257 21.4568 23.6364 21.4568C23.347 21.4568 23.0695 21.5717 22.865 21.7763C22.6604 21.9809 22.5454 22.2583 22.5454 22.5476Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_b_18680_80167"
                    x="-48"
                    y="-48"
                    width="152"
                    height="152"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feGaussianBlur in="BackgroundImage" stdDeviation="24" />
                    <feComposite
                      in2="SourceAlpha"
                      operator="in"
                      result="effect1_backgroundBlur_18680_80167"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_backgroundBlur_18680_80167"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>

              <p
                class="text-center fs-16 fw-500 txt-gery-900"
              >{{ $t("workspace_setting.lbl_index_category_setting") }}</p>
            </div>
          </div>
          <div
            class="cs-item mb-2 flex items-center flex-col gap-2"
            v-if="hasHODOCredit && isOwnerWorkspace"
          >
            <div
              class="text-center cursor-pointer flex flex-col items-center justify-center rounded-2xl"
              @click="changeType('ws-mgmt/deposit-points')"
              style="width: 65px; height: 65px; background-color: #20419b"
            >
              <svg width="32" height="32" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                <path fill="white" d="m8 16l-2-3h1v-2h2v2h1zm7-15v8H1V1zm1-1H0v10h16z" />
                <path
                  fill="white"
                  d="M8 2a3 3 0 1 1 0 6h5V7h1V3h-1V2zM5 5a3 3 0 0 1 3-3H3v1H2v4h1v1h5a3 3 0 0 1-3-3"
                />
              </svg>
            </div>
            <p class="text-center fs-16 fw-500 txt-gery-900">{{ $t("Nạp điểm") }}</p>
          </div>
          <div class="cs-item mb-2 flex items-center flex-col gap-2" v-if="isOwnerWorkspace">
            <div
              class="text-center cursor-pointer flex flex-col items-center justify-center rounded-2xl"
              @click="changeType('services')"
              style="width: 65px; height: 65px; background-color: #20419b"
            >
              <img src="/images/icon-service.svg" alt />
            </div>
            <p class="text-center fs-16 fw-500 txt-gery-900">{{ $t("Dịch vụ") }}</p>
          </div>
          <!-- <div v-else class="cs-item mb-2 flex items-center flex-col gap-2"></div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appUtils from '../../utils/appUtils'
import { APP_MODE } from '../../utils/constants'
export default {
  data () {
    return {
      clinic: null,
      showMenu: true
    }
  },
  name: 'TypeBarClinicManage',
  props: ['type'],
  computed: {
    isOwnerWorkspace () {
      let clinic = this.$globalClinic
      let user = this.$user
      if (!clinic || !clinic.id || !user || !user.doctor) return
      return clinic.doctor_id === user.doctor.id
    },
    getDate (date_time) {
      let dt = window.moment(date_time)
      // let hm = dt.clone().format('HH:mm')
      let dd = dt.clone().format('ddd')
      let d = dt.clone().format('DD')
      let m = dt.clone().format('MM')
      let y = dt.clone().format('YYYY')
      return dd + ', ' + 'Ngày ' + d + ' tháng ' + m + ' năm ' + y
    },
    getDtTop () {
      return this.moment()
        .locale(this.$lang)
        .format('HH:mm, DD/MM/YYYY')
    },
    hasHODOCredit () {
      return (
        (this.$appMode === APP_MODE.workspace
          ? this.$featureWsList && this.$featureWsList['credit']
          : false) || false
      )
    }
  },
  mounted () {
    this.clinic_id = this.$clinicId
    this.getDocterClinic()
    var size = window.$('body').width()
    if (size >= 768) {
      this.showMenu = true
    } else {
      this.showMenu = false
    }
  },
  methods: {
    changeType (str_type) {
      this.$router.push({ path: `/${str_type}` }).catch(() => {})
    },
    async getDocterClinic () {
      let self = this
      await self.$rf
        .getRequest('DoctorRequest')
        .getDoctorClinics(self.clinic_id)
        .then(res => {
          self.clinic = res.data
        })
    },
    async joinMeet () {
      if (!this.clinic.meet_room_id) {
        alert(
          // eslint-disable-next-line standard/computed-property-even-spacing
          this.$t('workspace_setting.lbl_meet_workspace_not_exist')[
            this.$orgModel
          ]
        )
        return
      }
      const meeting_id = this.clinic.meet_room_id
      let data = await this.$rf
        .getRequest('DoctorRequest')
        .showMeetRoom(meeting_id)
      if (data.data) {
        let dm = ''
        if (process.env.NODE_ENV === 'development') {
          dm = 'https://dev.meet.hodo.com.vn/#/'
        } else {
          dm = 'https://meet.hodo.com.vn/#/'
        }
        let token = appUtils.getLocalToken()
        let routeData =
          dm + '_app/' + data.data.room?.room_name + '?token=' + token
        window.open(routeData, '_blank')
      }
    },
    handleRedirectEmrTemplate () {
      this.$router.replace({ name: 'EmrList' })
    }
  }
}
</script>

<style scoped>
.disabled {
  opacity: 0.3;
  pointer-events: none;
}

.cs-item {
  width: 200px;
}
</style>
